// extracted by mini-css-extract-plugin
module.exports = {"AppContent":"styles_AppContent__3IjW3"};